/**
 * True when a list is genuinely empty — nothing loaded yet — rather than a search or filter having
 * narrowed real rows to zero. `GatesView` and `RunsView` show `FirstRunHint` only in the former case; a
 * filtered-to-zero result keeps the table's plain "No rows." instead.
 */
export function isFirstRun(loading: boolean, count: number, search: string, filters: Record<string, string>): boolean {
    return !loading && count === 0 && !search && !Object.values(filters).some(Boolean)
}
